import e from"react";import p from"./ChildrenPopover.mjs";const l=({children:o,isShow:r,onHidePopover:t,classPopover:n})=>e.createElement(e.Fragment,null,r&&e.createElement(p,{classPopover:n,onHidePopover:t},o));export{l as Popover};
